import { render } from "./ResetPending.vue?vue&type=template&id=0f427828"
import script from "./ResetPending.vue?vue&type=script&lang=js"
export * from "./ResetPending.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__